import { Box, Center, useDisclosure } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import HomeRecommendationsCard from 'presentation/components/modules/home/HomeRecommendationsCard';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import { FC } from 'react';
import { useFetchHomeQuery } from 'rtkQuery/sharespro/queries/home';
import ConfirmAllOrdersModal from 'presentation/containers/modules/orders/ConfirmAllOrdersModal';

const HomeRecommendationsContainer: FC = () => {
  const [accountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { data, error, refetch } = useFetchHomeQuery({
    period,
    account_id: accountId,
  });

  const {
    isOpen: isConfirmationModalOpen,
    onOpen: openConfirmationModal,
    onClose: closeConfirmationModal,
  } = useDisclosure();

  const activeOrders = data ? data.orders.filter((order) => order.isAllowedToSend) : [];

  const wrapByCard = !data;
  let content;
  if (activeOrders.length > 0) {
    content = (
      <>
        <HomeRecommendationsCard
          orders={activeOrders}
          onApproveClicked={openConfirmationModal}
        />
        <ConfirmAllOrdersModal
          isOpen={isConfirmationModalOpen}
          onClose={closeConfirmationModal}
        />
      </>
    );
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  if (!content) {
    return null;
  }

  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return <Box mb="20px">{content}</Box>;
};

export default HomeRecommendationsContainer;
